<header>
  <app-header *ngIf="this.dataStore.config && this.dataStore.config !== 'false'"></app-header>
    <app-member-bar *ngIf="this.isLoggedIn()"></app-member-bar>
  <!-- <div class="govuk-width-container"> -->
    <div class="govuk-width-container">
      <div class="govuk-phase-banner">
        <p class="govuk-phase-banner__content">
          <strong class="govuk-tag govuk-phase-banner__content__tag">
            Beta
          </strong>
          <span class="govuk-phase-banner__text">
            This is a new service – your <a class="govuk-link" href="mailto:TDS@essex.gov.uk">feedback</a> will
            help us to improve it.
          </span>
        </p>
      </div>
    </div>
  <!-- </div> -->


</header>
<div *ngIf="status === 0">
  <h1 class="connectionErr">{{this.translatorService.getText('networkOffline')}}</h1>
</div>

<div class="container" *ngIf="status === 1">
  <!-- <app-member-bar></app-member-bar> -->
  <div *ngIf="loadIssue" class="govuk-width-container" style="overflow: auto;">

    <div class="govuk-error-summary" aria-labelledby="error-summary-title" role="alert" data-disable-auto-focus="true"
      data-module="govuk-error-summary">
      <div class="govuk-error-summary__body">
        <ul class="govuk-list govuk-error-summary__list">
          <li>
            <p class="warning-message">{{this.translatorService.getText('errorWarn')}}</p>
            <button class="govuk-button govuk-button--secondary"
              (click)="resetApp()">{{this.translatorService.getText('retry')}}</button>
            <ol>
              <li *ngFor="let error of this.errors">
                <p>{{error}}</p>
              </li>
            </ol>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <div class="govuk-width-container">
    <main class="govuk-main-wrapper">
      <div class="govuk-tabs" data-module="govuk-tabs">
        <h2 class="govuk-tabs__title">
          Contents
        </h2>

        <!-- <ul class="govuk-tabs__list">
          <ng-container *ngIf="this.config && this.dataStore.loggedIn">

            <li *ngIf="this.config?.customizable?.confirmed?.show" class="govuk-tabs__list-item"
              [class.govuk-tabs__list-item--selected]="checkRout('confirmed')">
              <button class="govuk-tabs__tab" (click)="goToCustomizable('confirmed')">
                Due
                <span *ngIf="this.dataStore.tabBookingsCounts">
                  ({{this.dataStore.tabBookingsCounts['confirmed']}})</span>
              </button>
            </li>
            <li *ngIf="this.config?.customizable?.arrived?.show" class="govuk-tabs__list-item"
              [class.govuk-tabs__list-item--selected]="checkRout('arrived')">
              <button class="govuk-tabs__tab" (click)="goToCustomizable('arrived')">
                Arrived
                <span *ngIf="this.dataStore.tabBookingsCounts">
                  ({{this.dataStore.tabBookingsCounts['arrived']}})</span>
              </button>
            </li>
            <li *ngIf="this.config?.customizable?.noShow?.show" class="govuk-tabs__list-item"
              [class.govuk-tabs__list-item--selected]="checkRout('noShow')">
              <button class="govuk-tabs__tab" (click)="goToCustomizable('noShow')">
                No Show
                <span *ngIf="this.dataStore.tabBookingsCounts">
                  ({{this.dataStore.tabBookingsCounts['noShow']}})</span>
              </button>
            </li>
            <li *ngIf="this.config?.customizable?.arrived_and_paid?.show" class="govuk-tabs__list-item"
              [class.govuk-tabs__list-item--selected]="checkRout('arrived_and_paid')">
              <button class="govuk-tabs__tab" (click)="goToCustomizable('arrived_and_paid')">
                Arrived and Paid
                <span *ngIf="this.dataStore.tabBookingsCounts">
                  ({{this.dataStore.tabBookingsCounts['arrived_and_paid']}})</span>
              </button>
            </li>
            <li *ngIf="this.config?.customizable?.rejected?.show" class="govuk-tabs__list-item"
              [class.govuk-tabs__list-item--selected]="checkRout('rejected')">
              <button class="govuk-tabs__tab" (click)="goToCustomizable('rejected')">
                Rejected
                <span *ngIf="this.dataStore.tabBookingsCounts">
                  ({{this.dataStore.tabBookingsCounts['rejected']}})</span>
              </button>
            </li>
            <li *ngIf="this.config?.set?.noBooking?.show" class="govuk-tabs__list-item"
              [class.govuk-tabs__list-item--selected]="checkRout('noBooking')">
              <button class="govuk-tabs__tab" (click)="goToPage('noBooking')">
                No booking
                <span >
                  ({{this.dataStore.tabNoBookingCount}})</span>
              </button>
            </li>
          </ng-container>
        </ul> -->
        <div class="govuk-tabs__panel">
          <router-outlet></router-outlet>
        </div>
      </div>
    </main>
  </div>
</div>

<footer>
  <app-footer></app-footer>
</footer>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-circus" [fullScreen]="true">
  <p style="color: white"></p>
</ngx-spinner>
